import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';
import Cart from './Cart';
import doctor from './doctor';
import VideoCall from './VideoCall';
import chatSlice from './chat';
import redDots from './redDots';
import cartSlice from './cartSlice'; // Import the cart slice
import disLike from './disLike';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import realTimeState from './realTimeState';

const persistConfig = {
    key: 'SHIFARA_CART',
    storage,
};
const persistedCartReducer = persistReducer(persistConfig, cartSlice);

// Create a type for the store's dispatch function
export const store = configureStore({
    reducer: {
        appReducer: reducer,
        cart: Cart, // after the development remove this files this is a previous file & only use for diagnostic products
        doctor,
        VideoCall,
        chat: chatSlice,
        redDots: redDots,
        cartSlice: persistedCartReducer,
        disLike: disLike,
        realTimeState: realTimeState,
    },
});

export const persistor = persistStore(store); // Create persistor for persisting state

// Define types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;